import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/solar")({
  beforeLoad: ({ search }) => {
    throw redirect({
      to: "/solar-savings-calculator",
      search: search as Record<string, unknown>,
      statusCode: 301,
    });
  },
});
